<template>
  <div>
    <section class="SubMenu tw-bg-gradient2-lr tw-py-6">
      <div class="ns-container">
        <h1 class="heading-white tw-text-center">
          All Member Pictures
        </h1>
      </div>
    </section>

    <section>
      <div class="tw-w-screen tw-p-2">
        <div>
          <div v-lazy-container="{ selector: 'div' }">
            <div class="tw-grid tw-grid-cols-6 tw-gap-2">
              <gallery
                :images="processedImages"
                :index="imageIndex"
                @close="imageIndex = null"
              />
              <div
                v-for="(image, imgIndex) in images"
                :key="imgIndex"
                class="tw-w-full tw-h-full"
                @click="imageIndex = imgIndex"
              >
                <img :src="`${$api}${image.thumbUrl}`">
              </div>
            </div>
            <!-- <div -->
            <!-- v-for="(image, key) in images" -->
            <!-- :key="key" -->
            <!-- class="item" -->
            <!-- :data-src="`${$api}${image.imageUrl}`" -->
            <!-- :data-sub-html="caption(image)" -->
            <!-- > -->
            <!-- <img -->
            <!-- v-lazy="`${$api}${image.thumbUrl}`" -->
            <!-- height="150" -->
            <!-- > -->
            <!-- <div class="mask" /> -->
            <!-- </div> -->
            <infinite-loading
              identifier="all-pictures"
              spinner="circles"
              @infinite="infiniteHandler"
            >
              <div slot="spinner">
                Loading...
              </div>
              <div slot="no-more">
                No more message
              </div>
              <div slot="no-results">
                No results message
              </div>
            </infinite-loading>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PagePictures', // important

  components: {
    InfiniteLoading: () => import('vue-infinite-loading'),
    gallery: () => import('vue-gallery'),
  },

  data() {
    return {
      page: 1,
      images: [],

      imageIndex: null,
      gallery: null,
      galleryLoaded: false,
    };
  },

  computed: {
    processedImages() {
      return this.images.map((image) => ({
        title: image.user.profile.nickname,
        // description: '<a href="google.com" target="_blank">test</a>',
        href: `${this.$api}${image.imageUrl}`,
      }));
    },
  },

  methods: {
    infiniteHandler($state) {
      this.$http
        .get('/api/admin/member-pictures', {
          params: {
            page: this.page,
          },
        })
        .then((response) => {
          if (response.data.length) {
            this.page += 1;
            this.images.push(...response.data);
            $state.loaded();
          } else {
            $state.complete();
          }
        });
    },

    caption(image) {
      // {$user->profile['nickname']} ({$user->profile['facebook']['user']['name']}) /
      // <a target='_blank' href='{$user->url()}'>Profile</a> /
      // <a target='_blank' href='https://fb.com/{$user->profile['facebook']['id']}'>Facebook</a>

      return `${image.user.profile.nickname} (${image.user.profile.facebook.user.name}) /
      <a target='_blank' href='/profile/${image.user.profile.id}'>Profile</a> /
      <a target='_blank' href='https://www.facebook.com/search/top/?q=${image.user.profile.facebook.user.name}'>Facebook (Search)</a>`;
    },
  },
};
</script>
